import './_service-dropdown.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem } from 'react-bootstrap';

import DropdownSubMenu from './subMenu';

/**
 *
 * @param items
 * @param handleSelect
 * @param activeValue
 * @param props (DropdownButton)
 * @description Все props подходят от DropdownButton (react-bootstrap)
 * @returns {JSX.Element|null}
 */
const ServicesDropdown = ({ items, handleSelect, activeValue, ...props }) => {
  const onSelect = (e, item) => {
    e.preventDefault();
    handleSelect(item);
  };

  if (items.length) {
    return (
      <DropdownButton {...props}>
        {items.map((item, index) => {
          if (item.subMenu) {
            return <DropdownSubMenu key={index} title={item.title} items={item.subMenu} pullRight={item.pullRight} onSelect={onSelect} />;
          }
          const actionId = props?.id ? `${props?.id}-${item.accessKey}` : `${item.accessKey}-${index}`;
          return (
            <MenuItem id={actionId} active={activeValue === item.value} eventKey={index} key={index} onClick={(e) => onSelect(e, item)}>
              {item.title}
            </MenuItem>
          );
        })}
      </DropdownButton>
    );
  }
  return null;
};

ServicesDropdown.defaultProps = {
  id: 'dropdown',
};

ServicesDropdown.propTypes = {
  items: PropTypes.array.isRequired,
  activeValue: PropTypes.any,
  handleSelect: PropTypes.func.isRequired,
  id: PropTypes.any,
};

export default ServicesDropdown;
